import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { formatDateDataGrid } from "src/utils/format-date"

import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterFormulaPremioTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }


    const updateRow = async (newRow) => {
        const {
            ID,
            IDPremio,
            FormulaPremio,
            TipoPremio,
            Montante,
            DiasFinal,
            TipoDias,
            BaseDias,
            TPFReferencia,
            DiasTaxaReferencia,
            FormulaReferencia,
            FormulaDesconto
        } = newRow

        const body = {
            IDPremio,
            FormulaPremio,
            TipoPremio,
            Montante,
            DiasFinal,
            TipoDias,
            BaseDias,
            TPFReferencia,
            DiasTaxaReferencia,
            FormulaReferencia,
            FormulaDesconto
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true
        },
        {
            field: 'IDPremio',
            headerName: 'IDPremio',
            minWidth: 110,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'FormulaPremio',
            headerName: 'FormulaPremio',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'TipoPremio',
            headerName: 'TipoPremio',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Montante',
            headerName: 'Montante',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DiasFinal',
            headerName: 'DiasFinal',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoDias',
            headerName: 'TipoDias',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'BaseDias',
            headerName: 'BaseDias',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Fluxo',
            headerName: 'Fluxo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TPFReferencia',
            headerName: 'TPFReferencia',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DiasTaxaReferencia',
            headerName: 'DiasTaxaReferencia',
            minWidth: 150,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'FormulaReferencia',
            headerName: 'FormulaReferencia',
            minWidth: 180,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'FormulaDesconto',
            headerName: 'FormulaDesconto',
            minWidth: 180,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter={true}
            useDeleteButton={false}
        />
    )
}

ParameterFormulaPremioTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterFormulaPremioTable
